import { QTypography, QAutocomplete, QTextField } from '@kw/quokka-ui';
import { Box } from '@mui/material';
import { Clear, ExpandMore } from '@mui/icons-material';
import { useFetchService } from '../../utils/fetchService';
import { useLocalStorage } from '../../utils/useLocalStorage';

export const OrganizationDropdown = ({
  setSelectedOrganization,
  hasAllOption = false,
  defaultOrganization,
}: {
  setSelectedOrganization: (organizationId: string) => void;
  hasAllOption?: boolean;
  defaultOrganization?: string;
}) => {
  const [accessToken = ''] = useLocalStorage('accessToken', '');
  const { data: organizations = [] } = useFetchService('/organizations/list', accessToken);

  const organizationOptions = [hasAllOption ? { name: 'All Organizations', id: 'all' } : null, ...organizations]
    .filter(Boolean)
    .map(org => ({
      label: org.name,
      value: org.id,
    }));

  const defaultOption = defaultOrganization ? organizationOptions.find(o => o.value === defaultOrganization) : undefined;

  return (
    <Box p={2}>
      <QTypography variant="h4Bold">Organization</QTypography>
      <QAutocomplete
        key={defaultOption?.value ?? 'none'}
        options={organizationOptions}
        defaultValue={defaultOption}
        onChange={(_, selection) => setSelectedOrganization(selection?.value ?? '')}
        popupIcon={<ExpandMore fontSize="small" />}
        clearIcon={<Clear fontSize="small" />}
        renderInput={params => <QTextField placeholder="Select Organization" outlinedWithTitle {...params} size="small" />}
      />
    </Box>
  );
};
